// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__J9isy","summary":"CartItem_summary__lFRgY","price":"CartItem_price__KTtJC","amount":"CartItem_amount__maz5V","actions":"CartItem_actions__hIr1C"};